import { API_BASE } from "../config/api";
 
async function fetchWithAuth(path: string, init: RequestInit = {}) {
  const finalInit: RequestInit = {
    ...init,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(init.headers || {})
    }
  };
 
  let res = await fetch(API_BASE + path, finalInit);
 
  if (res.status === 401) {
    const refresh = await fetch(API_BASE + "/api/auth/refresh", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" }
    });
 
    if (refresh.ok) {
      res = await fetch(API_BASE + path, finalInit);
    }
  }
 
  return res;
}
 
export default {
  login: async (email: string, password: string) => {
    try {
      const res = await fetch(API_BASE + "/api/auth/login", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });
 
      if (res.ok) {
        const data = await res.json();
        return { ok: true, data };
      } else {
        const errorData = await res.json();
        return { ok: false, error: errorData.error || "Login fehlgeschlagen" };
      }
    } catch (error) {
      return { ok: false, error: "Netzwerkfehler" };
    }
  },
 
  logout: async () => {
    await fetchWithAuth("/api/auth/logout", { method: "POST" });
  },
 
  getMe: async () => {
    try {
      const res = await fetchWithAuth("/api/auth/me", { method: "GET" });
      if (res.ok) {
        const data = await res.json();
        return { ok: true, data };
      }
      return { ok: false };
    } catch (error) {
      return { ok: false };
    }
  }
};